import { render } from "./filterProductType.vue?vue&type=template&id=4c4d23c7&scoped=true"
import script from "./filterProductType.vue?vue&type=script&lang=js"
export * from "./filterProductType.vue?vue&type=script&lang=js"

import "./filterProductType.vue?vue&type=style&index=0&id=4c4d23c7&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4c4d23c7"]])

export default __exports__